import Component from '../inherited/Component'
import Helpers from '../lib/Helpers' 

export default class BenefitSection extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }

  mount () {
    const accordions = this._elem.querySelectorAll('summary');
    accordions.forEach(accordion => {
        accordion.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.target.closest('details').classList.contains('opened') ? this._closeAccordion(event.target.closest('details')) : this._openAccordion(event.target.closest('details'))
        });
    });
  }

  _openAccordion(details) {
    details.setAttribute('open', true)
    details.classList.add('opened')
    if(window.innerWidth > 989) {
      const accordion = details.closest('.accordion')
      const accordions = [...document.querySelectorAll('.benefit-section .accordion')]
      accordions.filter((acc) => acc !== accordion).forEach((acc) => {
        acc.classList.add('hide-i')
      });
    }
  }
  
  _closeAccordion(details) {
    details.removeAttribute('open')
    details.classList.remove('opened')
    if(window.innerWidth > 989) {
      const accordion = details.closest('.accordion')
      const accordions = [...document.querySelectorAll('.benefit-section .accordion')]
      accordions.filter((acc) => acc !== accordion).forEach((acc) => {
        acc.classList.remove('hide-i')
      });
    }
  }
}